// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13 2L13 22H11L11 2L13 2ZM2 5L9 5L9 19H2L2 5ZM15 5L22 5V19H15L15 5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-component-divider-horizontal-filled')
export default class ComponentDividerHorizontalFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-divider-horizontal-filled',
    }
  }
}
